export default __webpack_public_path__ + "static/timeline-board-ef756ec47fecfd8b912dfad5da569267.mp4";